import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Loading from "../../../hoc/Loading/Loading";
import axios from "../../../axios";
import { CSVLink } from "react-csv";
import {
  groupContentFields,
  groupPrivacyStatusDesc,
  table_column_names,
  task_priority,
} from "../../../utils/constants";
import * as actionCreators from "../../../modules/actions/index";
import { connect } from "react-redux";
import * as url from "../../../utils/url";
import { whiteLabelStyling, isUserRemoved } from "../../../utils/constants";
import moment from "moment";
import ActionsTable from "../../weekly-wins/ActionsTable";
import {
  Modal,
  ModalBody,
  Button,
  ListGroupItem,
  Progress,
  DropdownMenu,
  DropdownToggle,
  Dropdown,
  ModalHeader,
} from "reactstrap";
import CreateStoryForm from "../Components/GroupStory.jsx";
import noPlanning from "../../../assets/onboarding/ww.png";
import loadingItems from "../../../assets/placeholders/kpi_available.svg";
import { isMobile } from "../../../utils/deviceInfo";
import { inRange } from "lodash";

class MetricsPlanning extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menu: "",
      planning: [],
      dropdownOpen: false,
      isLoaded: false,
    };
  }

  getAllActions = () => {
    let { id } = this.props.match.params;
    if (this.props.renderIntoMetricsPopup) {
      id = this.props.group._id;
    }
    let that = this;
    let payload = {
      groupId: id,
      modelName: "Task",
      modelType: "action",
      noLoader: true,
    };

    axios.post(url.getSingleGroupItems, payload).then(({ data }) => {
      const dataList = data.data.items.filter(x =>
        ["action", "subAction"].includes(x.type)
      );
      console.log(dataList);
      that.setState({
        planning: dataList,
        isLoaded: true,
      });
    });
  };

  componentDidMount() {
    this.props.highlightMenu("P");
    this.getAllActions();
  }

  viewAction = item => {
    if (item.type == "action") {
      this.props.history.push(`/home/planning/${item._id}`);
    } else {
      this.props.history.push(`/home/enterprise-associatedActions/${item._id}`);
    }
  };

  assignedUserCheck = task => {
    let assignedUser =
      task.assignedTo && task.assignedTo.firstName ? task.assignedTo : false;
    let currentUser = this.props.user.profile;
    if (task && assignedUser) {
      let assignedUserFullName = assignedUser.lastName
        ? assignedUser.firstName + " " + assignedUser.lastName
        : assignedUser.firstName
        ? assignedUser.firstName
        : "";

      let taskOwner =
        task.ownerFullName && task.isAnonymous != true
          ? task.ownerFullName
          : "Anonymous";

      if (task.assignedTo._id.toString() == currentUser._id.toString()) {
        taskOwner = task.ownerFullName;
      }

      assignedUser = isUserRemoved(task.assignedTo)
        ? "Inactive User"
        : assignedUser;
      taskOwner = isUserRemoved(taskOwner) ? "Inactive User" : taskOwner;

      return (
        <div className="allTasksAssignedUser">
          Assigned to {assignedUserFullName} by {taskOwner}
          {/* <span className="sendReminder" onClick={this}>Remind?</span> */}
        </div>
      );
    }
  };

  checkProgressBarValue = task => {
    let res;
    if (
      task.percentComplete &&
      task.percentComplete.length > 0 &&
      task.percentComplete[0].value
    ) {
      res = task.percentComplete[0].value;
    } else if (
      task.incompleteDate &&
      new Date(task.incompleteDate).valueOf() != NaN
    ) {
      res = 0;
    } else if (
      task.completedDate &&
      new Date(task.completedDate).valueOf() != NaN
    ) {
      res = 100;
    } else if (
      task.incompleteDate &&
      task.completedDate &&
      new Date(task.incompleteDate).valueOf() != NaN &&
      new Date(task.completedDate).valueOf() != NaN
    ) {
      if (task.completedDate > task.incompleteDate) {
        res = 100;
      } else {
        res = 0;
      }
    } else {
      res = 0;
    }
    return res;
  };

  createdByTask = task_copy => {
    let currentUser = this.props.user.profile;
    let res;
    console.log(task_copy.userId, task_copy.assignedTo);
    let isUserRemovedTest = isUserRemoved(task_copy.userId);
    if (isUserRemovedTest) {
      res = " Inactive User";
    } else if (task_copy.isAnonymous) {
      if (task_copy.userId.toString() != currentUser._id.toString()) {
        if (
          task_copy.assignedTo &&
          task_copy.assignedTo._id &&
          task_copy.assignedTo._id.toString() == currentUser._id.toString()
        ) {
          res = ` ${task_copy.userId.firstName} ${task_copy.userId.lastName}`;
        } else {
          res = " Anonymous";
        }
      } else {
        res = " You";
      }
    } else {
      if (task_copy.userId.toString() == currentUser._id.toString()) {
        res = " You";
      } else {
        res = ` ${task_copy.userId.firstName} ${task_copy.userId.lastName}`;
      }
    }
    return res;
  };

  removeGroup = item => {
    let { planning } = this.state;
    if (this.props.group) {
      let payload = {
        modelId: item._id,
        modelName: "Task",
        itemType: item.type,
        groupId: this.props.group._id,
        noLoader: true,
      };

      // console.log('item -- ', item)

      // let u_planning =  planning.filter(e=> e.modelId._id != item._id)

      this.setState(prevState => ({
        planning: prevState.planning.filter(e => e._id != item._id),
      }));

      let that = this;

      axios.post(url.removeGrpItem, payload).then(({ data }) => {
        // let result =  linkedGrp.filter(e=>e._id!=modelDoc._id)
        // let doc = {
        //   ...selected,
        //   ...modelDoc.groupId
        // }
        that.setState({
          isRemoved: true,
          // isSuccess:true,
          // selected:null,
          // linkedGrp:result,  modDoc:doc,
          // groupList:[ doc ,...this.state.groupList],
          // displayItems:result
          // groupList:
          // isSuccessMsg: 0,
          // selected: {...selected, ...data.data}
        });
      });
    }
  };

  renderPlanning = tasks => {
    const { orgAdmin } = this.props.user.profile;

    let { planning } = this.state;

    return planning.map((item, index) => (
      <ListGroupItem
        key={item._id + index}
        className={
          item.isDeleted != true &&
          !item.completedDate &&
          item.dueDate &&
          item.dueDate != null &&
          item.dueDate != undefined
            ? moment(item.dueDate).format("YYYY-MM-DD") <
              moment().format("YYYY-MM-DD")
              ? "weekly-wins-todos dueDatePast"
              : "weekly-wins-todos"
            : "weekly-wins-todos"
        }
        style={whiteLabelStyling(
          ["borderColor"],
          this.props.user.profile.organizationId
        )}
      >
        <div className="objectives">
          <div className="grp_single_page_actions_item_type">
            {item.type == "action" ? (
              "Action"
            ) : (
              <span>
                Objective
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="22"
                  style={whiteLabelStyling(
                    ["backgroundColor"],
                    this.props.user.profile.organizationId
                  )}
                  fill="currentColor"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M2 2.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H2zM3 3H2v1h1V3z"
                  />
                  <path d="M5 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM5.5 7a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9zm0 4a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9z" />
                  <path
                    fillRule="evenodd"
                    d="M1.5 7a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V7zM2 7h1v1H2V7zm0 3.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H2zm1 .5H2v1h1v-1z"
                  />
                </svg>
              </span>
            )}
          </div>
          {item.title} {item.completedDate ? "(Completed)" : ""}
          {!item.completedDate &&
          !item.deletedDate &&
          !item.dueDate &&
          item.type == "action" ? (
            <span className="task_ongoing_txt">On-going</span>
          ) : null}
          {item.isDeleted != true &&
          !item.completedDate &&
          item.dueDate &&
          item.dueDate != null &&
          item.dueDate != undefined ? (
            moment(item.dueDate).format("YYYY-MM-DD") <
            moment().format("YYYY-MM-DD") ? (
              <span className="allTasksCalendarContainer">
                due on <i className="flaticon-calendar ml5"></i>{" "}
                <span className="allTasksDueDate">
                  {moment(item.dueDate).format("MMM D, YYYY")}{" "}
                </span>
                <span className="dueDatePastTxt">(PAST DUE)</span>
              </span>
            ) : (
              <span className="allTasksCalendarContainer">
                due on <i className="flaticon-calendar ml5"></i>{" "}
                <span className="allTasksDueDate">
                  {moment(item.dueDate).format("MMM D, YYYY")}{" "}
                </span>
              </span>
            )
          ) : null}
        </div>

        <Dropdown
          isOpen={this.state.dropdownOpen == item._id}
          className="grp_single_page_actions_dd"
          toggle={() => this.toggle(item._id)}
        >
          <DropdownToggle
            tag="span"
            className="chart-item-menu"
            onClick={() => this.toggle(item._id)}
            data-toggle="dropdown"
            aria-expanded={this.state.dropdownOpen == item._id}
          >
            <i
              className="chart-item-menu flaticon-menu-1"
              style={{ cursor: "pointer" }}
            ></i>
          </DropdownToggle>

          <DropdownMenu
            right
            className="chart-dropdown"
            style={{ padding: "0" }}
          >
            <div
              className="chart-list-dropdown-options"
              onClick={() => this.viewAction(item)}
              // onClick={()=>this.navigateToChart(chart)}
            >
              <i className="chart-item-menu flaticon-vision" />
              <span className="chart-list-dropdown-options-text">
                View {item.type == "action" ? "Action" : "Objective"}
              </span>
            </div>

            <div
              className="chart-list-dropdown-options"
              onClick={() => this.removeGroup(item)}
            >
              <span className="chart-item-menu flaticon-trash" />
              <span className="chart-list-dropdown-options-text">
                Remove from Group
              </span>
            </div>
          </DropdownMenu>
        </Dropdown>

        {/* <span className="viewLinkedActionEO" onClick={()=> this.viewAction(item)}>
                <span className='viewLinkedActionEOTxt'> View Action </span>
              </span> */}

        <div className="grp_single_page_planning_date">
          <span>{`by ${this.createdByTask(item)} on ${moment(
            item.createdOn
          ).format("MMM D, YYYY")}`}</span>

          {item.lastUpdate ? (
            <span>{` * Updated on ${moment(item.lastUpdate).format(
              "MMM D, YYYY"
            )}`}</span>
          ) : null}
        </div>

        {this.assignedUserCheck(item)}

        {item.completedDate ? (
          <div>
            <span className="">
              {" "}
              Completed on
              {/* <i className="flaticon-calendar ml5"></i>  */}
              <span className="">
                {" "}
                {moment(item.completedDate).format("MMM D, YYYY")}{" "}
              </span>
            </span>
          </div>
        ) : null}

        {item.completedDate && item.dueDate ? (
          <span className="">
            {" "}
            (previous) Due date of
            {/* <i className="flaticon-calendar ml5"></i>  */}
            <span className="">
              {" "}
              {moment(item.dueDate).format("MMM D, YYYY")}{" "}
            </span>
          </span>
        ) : null}

        {(!item.completedDate || item.completedDate == null) &&
        item.deletedDate ? (
          <span className="">
            {" "}
            Archived on
            {/* <i className="flaticon-calendar ml5"></i>  */}
            <span className="">
              {" "}
              {moment(item.deletedDate).format("MMM D, YYYY")}{" "}
            </span>
          </span>
        ) : null}

        {item.type == "action" ? (
          <div className="allTaskProgressContainer">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="30"
              fill="currentColor"
              className="bi bi-card-checklist allTaskProgressIcon"
              viewBox="0 0 16 16"
            >
              <path d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h13zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z" />
              <path d="M7 5.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm-1.496-.854a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 1 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0zM7 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm-1.496-.854a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 0 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0z" />
            </svg>
            {this.checkProgressBarValue(item) == 0 ? (
              <span className="zeroPercentProgress">0%</span>
            ) : null}
            <Progress
              className={
                this.checkProgressBarValue(item) == 100
                  ? "allTaskProgress progressCompleted"
                  : "allTaskProgress"
              }
              striped={this.checkProgressBarValue(item) == 100 ? false : true}
              // value="25"
              // animated
              // multi
              color="success"
              value={this.checkProgressBarValue(item)}
            >
              {this.checkProgressBarValue(item)}%
            </Progress>
          </div>
        ) : null}
        {/* <CollapseControl description={item.description} />    */}

        {item.type == "objective" && item.taskCounter ? (
          <div className="enterpriseName">
            Linked Actions ({item.taskCounter})
          </div>
        ) : null}

        {/* userId */}
        {/* {orgAdmin ||  this.props.user.profile._id.toString() == item.userId.toString() ?
              <div className="pull-right link-unlink unlinkActionEA">
                  <i className="unlink"></i>
                  <span onClick={() => this.unLinkActionFromObjective(item._id)}>Unlink</span>
                </div>
                :null
              } */}
      </ListGroupItem>
    ));
  };
  handleRemoveGroupUI = item => {
    return (
      <div
        className="chart-list-dropdown-options"
        onClick={() => this.removeGroup(item)}
      >
        <span className="chart-item-menu flaticon-trash" />
        <span className="chart-list-dropdown-options-text">
          Remove from Group
        </span>
      </div>
    );
  };
  checkProgressBarValue = task => {
    let res;
    if (
      task.percentComplete &&
      task.percentComplete.length > 0 &&
      task.percentComplete[0].value
    ) {
      res = task.percentComplete[0].value;
    } else if (
      task.incompleteDate &&
      new Date(task.incompleteDate).valueOf() != NaN
    ) {
      res = 0;
    } else if (
      task.completedDate &&
      new Date(task.completedDate).valueOf() != NaN
    ) {
      res = 100;
    } else if (
      task.incompleteDate &&
      task.completedDate &&
      new Date(task.incompleteDate).valueOf() != NaN &&
      new Date(task.completedDate).valueOf() != NaN
    ) {
      if (task.completedDate > task.incompleteDate) {
        res = 100;
      } else {
        res = 0;
      }
    } else {
      res = 0;
    }
    return res;
  };
  getData = actions => {
    const actionsToExport = actions.map(itm => ({
      name: itm.title,
      assignee: itm.assignedTo
        ? `${itm.assignedTo.firstName} ${itm.assignedTo.lastName}`
        : itm.assignedToDoc
        ? `${itm.assignedToDoc.firstName} ${itm.assignedToDoc.lastName}`
        : "No assignee",
      dueDate: moment(itm.dueDate).format("MMM D, YYYY"),
      progress:
        this.checkProgressBarValue(itm) === 0
          ? "Not started"
          : inRange(this.checkProgressBarValue(itm), 0, 99.99)
          ? this.checkProgressBarValue(itm) + " % "
          : "Complete",
      objective: itm.parentTaskTitle
        ? itm.parentTaskTitle
        : itm.parentTask
        ? itm.parentTask.item.title
        : "No objective",
      priority: task_priority(itm.priority),
    }));

    return actionsToExport;
  };
  render() {
    let { planning, isLoaded } = this.state;
    const { renderIntoMetricsPopup, actionsPopupOpen, toggle } = this.props;

    const actionsStaticHeaders = [
      { label: "Action Title", key: "name" },
      { label: "Assignee", key: "assignee" },
      { label: "Progress", key: "progress" },
      { label: "Linked Objective", key: "objective" },
      { label: "Due Date", key: "dueDate" },
      { label: "Priority", key: "priority" },
    ];

    return (
      <Modal isOpen={actionsPopupOpen}>
        <ModalHeader toggle={toggle} className="metrics-mobile-header">
          Group Planning
          {planning.length ? (
            <div
              className={`single_group_menu_events_export_btn ${
                isMobile ? "" : "ml-5"
              }`}
            >
              <CSVLink
                data={this.getData([...this.state.planning])}
                headers={actionsStaticHeaders}
                filename={`Group Actions - ${moment().format(
                  "MM/DD/YYYY"
                )}.csv`}
                target="_blank"
              >
                Export Metrics Actions To CSV
              </CSVLink>
            </div>
          ) : (
            ""
          )}
        </ModalHeader>
        <ModalBody>
          <span
            className={
              renderIntoMetricsPopup ? "" : "grp_single_page_stories_container"
            }
          >
            {isLoaded != true ? (
              <div
                className={
                  renderIntoMetricsPopup
                    ? "grp_single_page_metrics_popup_container"
                    : "grp_single_page_details_analytics_container"
                }
              >
                <span className="grp_single_page_no_analytics">
                  <img src={loadingItems} className="grpNoLinkedCharts" />{" "}
                  Loading...
                </span>
              </div>
            ) : isLoaded ? (
              planning && planning.length > 0 ? (
                <div
                  className={
                    renderIntoMetricsPopup
                      ? `mt-2 metrics-plan-container ${isMobile &&
                          "mobile-planning-height-metrics-popup"}`
                      : "grp_single_page_details_post_container grp_single_page_planning_container_items mt-5"
                  }
                >
                  <ActionsTable
                    onPageFilter
                    {...this.props}
                    table_params={{
                      ...table_column_names["planning"],
                      selected: table_column_names["planning"]["1"],
                    }}
                    hideAddActionButtons
                    isHidden={true}
                    getAllData={this.getAllActions}
                    allTasks={this.state.planning}
                    handleRemoveGroupUI={
                      renderIntoMetricsPopup ? null : this.handleRemoveGroupUI
                    }
                    plainTable
                    noEdit
                    searchActions
                  />
                </div>
              ) : (
                <div
                  className={
                    renderIntoMetricsPopup
                      ? "grp_single_page_metrics_popup_container"
                      : "grp_single_page_details_analytics_container"
                  }
                >
                  <span
                    className={
                      renderIntoMetricsPopup
                        ? "grp_single_page_metrics cursor-pointer"
                        : "grp_single_page_no_analytics cursor-pointer"
                    }
                    onClick={() => this.props.history.push(`/home/my-activity`)}
                  >
                    <img src={noPlanning} className="grpNoLinkedCharts" /> No
                    actions or objectives have been linked with Planning. Click
                    here to link items from Planning.
                    <div
                      className="grp_page_events_subtitle"
                      onClick={() =>
                        this.props.history.push(`/home/toolkit/all`)
                      }
                    >
                      Click here to link items from Planning.{" "}
                    </div>
                  </span>
                </div>
              )
            ) : null}
          </span>
        </ModalBody>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster,
    reports: state.reports,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onKpiMasterListFetched: data =>
      dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: data =>
      dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: data =>
      dispatch(actionCreators.updateProfileInfoSuccess(data)),
    updateNavBar: header => dispatch(actionCreators.navBarUpdate(header)),
    updateReport: dashboard => dispatch(actionCreators.updateReport(dashboard)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Loading(MetricsPlanning, axios)));
